import { FC } from "react";
import { Box, VStack } from "shared/components/Spor";

type TrainProps = { color: string };

export const Train: FC<TrainProps> = ({ color }) => (
  <VStack gap={0}>
    <Box w="12px" h="15px" bg={color} />
    <Box w="12px" h="12px" bg={color} borderRadius="100%" mt="-6px" />
  </VStack>
);
